import { graphql } from '@tn/foundation/graphql/__generated/gql';

export const editEmailCacheKey = 'editEmail';
export const editEmailQuery = graphql(/* GraphQL */ `
    query EditEmail {
        editEmail {
            success
        }
    }
`);
